import React from 'react'
import { Link } from 'react-router'
import { useNavigationContext } from 'components/Utility/NavigationContext/NavigationContext'

type AppLinkProps = React.AnchorHTMLAttributes<HTMLAnchorElement> & {
  path?: string | null,
}

const getCurrentOrigin = (ssrOrigin?: string) => {
  if (typeof window !== 'undefined') {
    return window.location.origin
  }
  return ssrOrigin ?? 'http://localhost'
}

/**
 * Link to a CMS path: internal pages go through the router,
 * files and other hosts open in a new tab, tel: links stay as they are.
 */
export const AppLink: React.FC<AppLinkProps> = (props) => {
  const { path, ...rest } = props
  const navigationContext = useNavigationContext()

  if (!path) {
    return <a {...rest} />
  }
  if (path.startsWith('tel:') || path.startsWith('mailto:')) {
    return <a {...rest} href={path} />
  }

  const origin = getCurrentOrigin(navigationContext.origin)
  const url = new URL(path, origin)
  const host = new URL(origin).hostname
  const hasExt = url.pathname.includes('.')

  if (hasExt || url.hostname !== host) {
    return <a {...rest} href={path} target={'_blank'} rel="noopener noreferrer" />
  }
  const relativePath = path.replace(/^https?:\/\//, '').replace(url.hostname, '')
  return <Link {...rest} to={relativePath} />
}
